import { getIndexColor } from '../../../utils/colorUtils';
import './visualization.css';


interface IndexBarProps {
  index: number; // 0-10
  color: string | number; // if number, use index color with this lightness - if string, this is a color

  confidence?: number; // 0-1
  secondDimension?: 'height' | 'opacity'

  height?: number;
  minHeight?: number;
  maxHeight?: number;

  maxWidth?: number;
  border?: string;
  trailColor?: string;

  duration?: number; // in seconds
}

export const IndexBar: React.FC<IndexBarProps> = ({
  index,
  color,

  confidence,
  secondDimension,

  height,
  minHeight,
  maxHeight,

  maxWidth,
  border,
  trailColor,

  duration,
}) => {

  const outerWidth = maxWidth ?? 60;
  const progressWidthPercentage = index * 10;

  const defaultMaxHeight = 8;
  const defaultMinHeight = 1.5;
  const defaultHeight = 5;

  let heightToUse = height ?? defaultHeight;
  if (secondDimension === 'height' && confidence !== undefined) {
    const maxHeightToUse = maxHeight ?? defaultMaxHeight;
    const minHeightToUse = minHeight !== undefined && minHeight < maxHeightToUse ? minHeight : defaultMinHeight;
    heightToUse = secondDimension === 'height' && confidence !== undefined ? (minHeightToUse + (confidence * (maxHeightToUse - minHeightToUse))) : maxHeightToUse;
  }


  const colorToUse = typeof color === 'number' ? getIndexColor(index, color) : color;
  const trailColorToUse = trailColor ?? '#00000022';

  const outerOpacity = secondDimension === 'opacity' && confidence !== undefined ? (0.8 + (confidence * 0.2)) : undefined;
  const innerOpacity = secondDimension === 'opacity' && confidence !== undefined ? (0.1 + (confidence * 0.9)) : undefined;

  return (
    <div
      className='index-bar-container'
      style={{
        width: outerWidth,
        height: heightToUse,
        opacity: outerOpacity,
      }}
    >

      <div
        className='index-bar'
        style={{
          width: '100%',
          height: heightToUse,
          backgroundColor: trailColorToUse,
          border: border,
        }}
      >
        <div
          className='index-bar-progress'
          style={{
            width: progressWidthPercentage + '%',
            height: '100%',
            backgroundColor: colorToUse,
            opacity: innerOpacity,
            transition: duration !== undefined ? `width ${duration}s ease-in-out` : undefined,
          }}
        />
      </div>
    </div>
  );
};
